// extracted by mini-css-extract-plugin
export default {"wrapper":"DescriptionField_wrapper__QjE+-"};